import { GuestRequestForQuotation, VerifiedRequestForQuotation } from '@ravago/shared/page-data/models/features';
import { Quotation } from '@ravago/shared/page-data/models/features/product-quotation.model';

export abstract class QuotationUtils {
  static async getQuotations(): Promise<Quotation[] | undefined> {
    const response = await fetch(`/api/customer/quotations`);
    if (response.ok) {
      return response.json();
    }
    return undefined;
  }

  static async requestQuotation(request: VerifiedRequestForQuotation) {
    const url = '/api/customer/quotation-requests';
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache',
      body: JSON.stringify(request)
    });

    if (!response.ok) return false;
    const result = await response.json();

    return result.success as boolean;
  }

  static async requestGuestQuotation(request: GuestRequestForQuotation) {
    const url = '/api/customer/quotation-requests';
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      cache: 'no-cache',
      body: JSON.stringify(request)
    });

    if (!response.ok) return false;
    const result = await response.json();

    return result.success as boolean;
  }
}
